import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'components/ui/button'
import { usePartners } from 'hooks/usePartnerAdmin'
import PartnersLayout from './PartnersLayout'
import CreatePartnerModal from './CreatePartnerModal'
import { formatUSDC } from './format'

const th =
  'text-left text-xs font-semibold uppercase text-neutral-500 px-3 py-2'
const td = 'px-3 py-2 text-sm border-t border-neutral-100'

const PartnersList: React.FC = () => {
  const { data, error, isLoading, mutate } = usePartners()
  const [createOpen, setCreateOpen] = useState(false)
  const partners = data ?? []

  return (
    <PartnersLayout
      title="Partners"
      actions={<Button onClick={() => setCreateOpen(true)}>New partner</Button>}
    >
      {error && (
        <div className="text-sm text-red-600 mb-3">
          Failed to load partners: {(error as Error).message}
        </div>
      )}
      {isLoading && <div className="text-sm text-neutral-600">Loading…</div>}
      {!isLoading && partners.length === 0 && !error && (
        <div className="text-sm text-neutral-600">No partners yet.</div>
      )}
      {partners.length > 0 && (
        <div className="overflow-x-auto border border-neutral-200 rounded-lg">
          <table className="min-w-full">
            <thead className="bg-neutral-50">
              <tr>
                <th className={th}>Handle</th>
                <th className={th}>Code</th>
                <th className={th}>Status</th>
                <th className={th}>Tier</th>
                <th className={th}>Sign-ups</th>
                <th className={th}>Active</th>
                <th className={th}>Earned</th>
                <th className={th}>Claimable</th>
                <th className={th}>Pending</th>
                <th className={th}>Paid</th>
              </tr>
            </thead>
            <tbody>
              {partners.map((p) => (
                <tr key={p.id} className="hover:bg-neutral-50">
                  <td className={td}>
                    <Link
                      to={`/partners/${p.id}`}
                      className="text-brand-primary font-medium"
                    >
                      {p.handle}
                    </Link>
                  </td>
                  <td className={td}>{p.code}</td>
                  <td className={td}>{p.status}</td>
                  <td className={td}>
                    {p.tier}
                    {p.tier_override ? ' (override)' : ''}
                  </td>
                  <td className={td}>{p.stats.sign_ups}</td>
                  <td className={td}>{p.stats.active_referrals}</td>
                  <td className={td}>
                    {formatUSDC(p.stats.earned_all_time_usdc)}
                  </td>
                  <td className={td}>{formatUSDC(p.stats.claimable_usdc)}</td>
                  <td className={td}>{formatUSDC(p.stats.pending_usdc)}</td>
                  <td className={td}>{formatUSDC(p.stats.paid_usdc)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <CreatePartnerModal
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onCreated={() => {
          setCreateOpen(false)
          mutate()
        }}
      />
    </PartnersLayout>
  )
}

export default PartnersList
